module.exports = __webpack_public_path__ + "static/herotablet-097f62fc35e0f0e9b11b1514fc019f6b.jpg";